/* tslint:disable */
/* eslint-disable */
import { FrageAuswahlOptionDisplayModel as AceXFoundPortalCoreCaqModelsFrageAuswahlOptionDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/frage-auswahl-option-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { FrageAuswahlOptionDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsFrageAuswahlOptionDisplayModelFormGroup } from '@/api/model-index';

export interface IFrageAuswahlDisplayModel {
  auswahl?: null | Array<AceXFoundPortalCoreCaqModelsFrageAuswahlOptionDisplayModel>;
  mainLanguageCode?: null | string;
}
export class FrageAuswahlDisplayModel extends BaseModel implements IFrageAuswahlDisplayModel {
  auswahl?: null | Array<AceXFoundPortalCoreCaqModelsFrageAuswahlOptionDisplayModel>;
  mainLanguageCode?: null | string;
}
class BaseFrageAuswahlDisplayModelFormGroup extends FormGroup {
  private static _instance: FrageAuswahlDisplayModelFormGroup;
  
  public static get Instance(): FrageAuswahlDisplayModelFormGroup {
    this._instance = new FrageAuswahlDisplayModelFormGroup({
      auswahl: new FormArray([]),
      mainLanguageCode: new FormControl(null),
    });

    return this._instance;
  }
}


export class FrageAuswahlDisplayModelFormGroup extends BaseFrageAuswahlDisplayModelFormGroup {
  public get Auswahl(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsFrageAuswahlOptionDisplayModelFormGroup> {
    return this.controls["auswahl"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsFrageAuswahlOptionDisplayModelFormGroup>;
  }
  public get MainLanguageCode(): FormControl {
    return this.controls["mainLanguageCode"] as FormControl;
  }
  

}

export module FrageAuswahlDisplayModelForm
  {
    export class FormFields
    {
      static _auswahl: string = "auswahl";
      static _mainLanguageCode: string = "mainLanguageCode";
    }
  }

